import { createRouter, createWebHistory } from "vue-router";
import axios from "axios";
import ConfigurationView from "@/permanencia/views/ConfigurationView.vue";
import DataView from "@/permanencia/views/DataView.vue";
import MainView from "@/ai_studio/views/MainView.vue";
import ModelView from "@/permanencia/views/ModelView.vue";
import AssistentsView from "@/assistents/views/AssistentsView.vue";
import DataDefinitions from "@/permanencia/views/DataDefinitions.vue";
import AuthResolver from "@/ai_studio/resolver/AuthResolver";
import DataResolver from "@/ai_studio/resolver/DataResolver";
import DataTypesResolver from "@/ai_studio/resolver/DataTypesResolver";
import Page403View from "@/ai_studio/views/Page403View.vue";
import Page404View from "@/ai_studio/views/Page404View.vue";
import ConfigurationResolver from "@/ai_studio/resolver/ConfigurationResolver";
import ModelsResolver from "@/ai_studio/resolver/ModelsResolver";
import AssistentsConfiguration from "@/assistents/views/configuration/AssistentsConfiguration.vue"
import AssistentsShare from "@/assistents/views/AssistentsShare.vue";
import AssistentsIntegration from "@/assistents/views/AssistentsIntegration.vue";
import AssistentsChat from "@/assistents/views/AssistentsChat.vue";
import AssistentChatResolver from '@/ai_studio/resolver/AssistentChatResolver.js';
import DashboardView from "@/assistents/views/DashboardView.vue";
import ContentGenerationView from "@/assistents/views/ContentGenerationView.vue";
import InsightIcon from "@/assistents/components/InsightsIcon.vue"
import AssistentIcon from "@/assistents/components/AssistentsIcon.vue"
import CatchmentConfigurationView from "@/captacao/views/ConfigurationView.vue"
import CatchmentView from "@/captacao/views/CatchmentView.vue";
import HomeView from "../views/HomeView.vue";
import HomeResolver from "@/ai_studio/resolver/HomeResolver.js";
import { useAuthStore } from "@/ai_studio/stores/auth";
import { PERMISSIONS } from "@/ai_studio/constants/permissions";
import { useUserStore } from "@/ai_studio/stores/user";

const routes = [
  {
    path: "/",
    name: "home",
    meta: {title: ""},
    component: MainView,
    children: [
      {
        path: "/",
        name: "home-page",
        component: HomeView,
        meta: {
          title: "Home",
          helpKey: "Home",
          icon: InsightIcon,
        },
        beforeEnter: HomeResolver
      },
      {
        path: "/data",
        name: "data",
        component: DataView,
        meta: {
          title: "Insights",
          helpKey: "insights-captacao",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS],
        },
        beforeEnter: DataResolver,
      },
      {
        path: "/model",
        name: "model",
        component: ModelView,
        meta: {
          title: "Insights",
          helpKey: "Insights",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS],
        },
        beforeEnter: ModelsResolver,
      },
      {
        path: "model-catchment",
        name: "modelCatchment",
        meta: { 
          title: "Captação", 
          helpKey: "insights-captacao",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS],
         },
        component: CatchmentView,
      },
      {
        path: "/definitions/:id",
        name: "datadefinitions",
        component: DataDefinitions,
        meta: {
          title: "Insights",
          helpKey: "Insights",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS],
        },
        beforeEnter: DataTypesResolver,
      },
      {
        path: "/configuration",
        name: "configuration",
        component: ConfigurationView,
        meta: {
          title: "Insights",
          helpKey: "Insights",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS],
        },
        beforeEnter: ConfigurationResolver,
      },
      {
        path: "/resources-dashboard",
        name: "resources-dashboard",
        component: DashboardView,
        meta: {
          title: "Monitoramento de Recursos",
          helpKey: "Assistentes",
          icon: InsightIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.MONITORAMENTO_USO],
        }
      },
      {
        path: "configuration/catchment",
        name: "catchment",
        meta: { title: "Captação", 
          helpKey: "insights-captacao",
          icon: InsightIcon,
          requiresInsightsContract: true,
          requiredPermissions: [PERMISSIONS.INSIGHTS]
        },
        component: CatchmentConfigurationView,
      },
      {
        path: "/content-generation",
        name: "content-generation",
        component: ContentGenerationView,
        meta: {
          title: "Geração de conteúdo",
          helpKey: "Assistentes",
          icon: InsightIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.GERACAO_CONTEUDO],
        },
      },
      {
        path: "/assistentes",
        name: "assistentes",
        component: AssistentsView,
        meta: {
          title: "Assistentes",
          helpKey: "Assistentes",
          icon: AssistentIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.ASSISTENTES],
        },
      },
      {
        path: "/assistentes/create",
        name: "assistentesCreation",
        component: AssistentsConfiguration,
        meta: {
          title: "Assistentes",
          helpKey: "Assistentes",
          icon: AssistentIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.ASSISTENTES],
        },
      },
      {
        path: "/assistentes/:key",
        name: "assistentesEdit",
        component: AssistentsConfiguration,
        meta: {
          title: "Assistentes",
          helpKey: "Assistentes",
          icon: AssistentIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.ASSISTENTES],
        },
      },
      {
        path: "/assistentes/:key/compartilhar",
        name: "assistentsShare",
        component: AssistentsShare,
        meta: {
          title: "Assistentes",
          helpKey: "Assistentes",
          icon: AssistentIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.ASSISTENTES],
        },
      },
      {
        path: "/assistentes/:key/integracao",
        name: "assistentsIntegration",
        component: AssistentsIntegration,
        meta: {
          title: "Assistentes",
          helpKey: "Assistentes",
          icon: AssistentIcon,
          showPlanBadge: true,
          requiredPermissions: [PERMISSIONS.ASSISTENTES],
        },
      },
    ]
  },
  {
    path: "/auth/:jwt",
    name: "auth",
    meta: { title: "Permanência" },
    component: Page403View,
    beforeEnter: AuthResolver,
  },
  {
    path: "/assistentes/:key/chat",
    name: "assistentsChat",
    meta: { title: "Assistente virtual",  public: true},
    component: AssistentsChat,
    beforeEnter: AssistentChatResolver
  },
  {
    path: "/403",
    name: "403",
    meta: { title: "403" },
    component: Page403View,
  },
  {
    path: "/:catchAll(.*)",
    meta: { title: "404" },
    component: Page404View,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "AI Studio";

  const authStore = useAuthStore();
  const userStore = useUserStore();

  if (to.meta.public || to.name === "403" || to.name === "auth") {
    return next();
  }

  if (!authStore.isAuthenticated) {
    const authenticated = await authStore.checkAuth();

    if (!authenticated) {
      return next({ name: "403" });
    }
  }

  if (to.meta.requiredPermissions?.length) {
    const hasPermission = userStore.hasAnyPermission(to.meta.requiredPermissions);
    if (!hasPermission) {
      return next({ name: "403" });
    }
  }

  if (to.meta.requiresInsightsContract) {
    try {
      const { data } = await axios.get("/api/assistents/resources/insights-status");

      if (!data?.contracted) {
        return next({ name: "403" });
      }
    } catch (error) {
      return next({ name: "403" });
    }
  }

  return next();
});

export default router;
